(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[883],{

/***/ 6446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ LocalStorageEnum; }
/* harmony export */ });
/* unused harmony export getChattingNoticeKey */
var LocalStorageEnum;
(function(LocalStorageEnum) {
    LocalStorageEnum["AuthToken"] = "AUTH_TOKEN";
    LocalStorageEnum["FundoraAuthToken"] = "FUNDORA_AUTH_TOKEN";
    LocalStorageEnum["RecentStocks"] = "THERICH_RECENT_STOCKS_2";
    LocalStorageEnum["Locale"] = "THERICH_LOCALE";
    LocalStorageEnum["LoginPlatform"] = "THERICH_LOGIN_PLATFORM";
    LocalStorageEnum["CommunityRecentSearches"] = "THERICH_COMMUNITY_RECENT_SEARCHES";
    LocalStorageEnum["CommunityTimelineInfluencer"] = "THERICH_COMMUNITY_TIMELINE_INFLUENCER";
    LocalStorageEnum["metaPortfolioLock"] = "THERICH_META_PORTFOLIO_LOCK";
    LocalStorageEnum["NewsCountry"] = "THERICH_NEWS_COUNTRY";
    LocalStorageEnum["DividendCountry"] = "THERICH_DIVIDEND_COUNTRY";
    LocalStorageEnum["OnBoardingIntro"] = "ON_BOARDING_INTRO";
    LocalStorageEnum["InvisibleAds"] = "THERICH_INVISIBLE_ADS";
    LocalStorageEnum["NewsRecentSearches"] = "THERICH_NEWS_RECENT_SEARCHES";
    LocalStorageEnum["FavoriteAssetsReorder"] = "THERICH_FAVORITE_ASSETS_REORDER";
    LocalStorageEnum["LoanInterestCalculatorValues"] = "LOAN_INTEREST_CALCULATOR_VALUES";
    LocalStorageEnum["ProfessionalInvestorApplicationOptionValues"] = "PROFESSIONAL_INVESTOR_APPLICATION_OPTION_VALUES";
    LocalStorageEnum["LastFocusedVideoId"] = "LAST_FOCUSED_VIDEO_ID";
})(LocalStorageEnum || (LocalStorageEnum = {}));
var getChattingNoticeKey = function(param) {
    var chatId = param.chatId;
    return "THERICH_CHAT_NOTICE_".concat(chatId);
};


/***/ }),

/***/ 438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sendErrorLog; }
});

;// CONCATENATED MODULE: ./src/constants/env.ts
var IS_PRODUCTION_OPERATION = (/* unused pure expression or super */ null && ("development" === "production"));
var IS_PRODUCTION = "production" === "production";
var IS_DEVELOPMENT = (/* unused pure expression or super */ null && ("production" === "development"));
var IMAGE_SERVER = "https://images.therich.io";

;// CONCATENATED MODULE: ./src/service/error-log/index.ts

function sendErrorLog(error) {
    if (IS_PRODUCTION) {
    // appsignal.sendError(error)
    } else {
        console.error(error);
    }
};


/***/ }),

/***/ 8883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ locale_provider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js
var I18nextProvider = __webpack_require__(6339);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 7 modules
var i18next = __webpack_require__(5751);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(7715);
// EXTERNAL MODULE: ./src/types/locale.ts
var types_locale = __webpack_require__(2907);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(8668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(5892);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(1224);
// EXTERNAL MODULE: ./src/service/error-log/index.ts + 1 modules
var error_log = __webpack_require__(438);
;// CONCATENATED MODULE: ./src/service/error-log/internationalization-error.ts





var InternationalizationError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(InternationalizationError, Error1);
    var _super = (0,_create_super/* default */.Z)(InternationalizationError);
    function InternationalizationError(lng, ns, key, fallbackValue) {
        (0,_class_call_check/* default */.Z)(this, InternationalizationError);
        var _this;
        _this = _super.call(this, "lng: [".concat(lng.join(), "], ns: ").concat(ns, ", key: ").concat(key, ", fallbackValue: ").concat(fallbackValue));
        _this.name = "InternationalizationError";
        return _this;
    }
    return InternationalizationError;
}((0,_wrap_native_super/* default */.Z)(Error));
function sendInternationalizationError(lngs, ns, key, fallbackValue) {
    if (key === fallbackValue) {
        (0,error_log/* default */.Z)(new InternationalizationError(lngs, ns, key, fallbackValue));
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
;// CONCATENATED MODULE: ./src/i18n/languages/index.ts


var lngs = [
    types_locale/* LocaleEnum.ko */.U.ko,
    types_locale/* LocaleEnum.en */.U.en
];
var _obj;
var languages = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types_locale/* LocaleEnum.ko */.U.ko, {}), (0,_define_property/* default */.Z)(_obj, types_locale/* LocaleEnum.en */.U.en, {}), _obj);
var req = __webpack_require__(1197);
req.keys().forEach(function(key) {
    var name = key.replace(/\.\/(.+)\.yml$/, "$1");
    lngs.forEach(function(lng) {
        languages[lng][name] = req(key)[lng];
    });
});
/* harmony default export */ var i18n_languages = (languages);

;// CONCATENATED MODULE: ./src/i18n/index.ts





var en = i18n_languages.en, ko = i18n_languages.ko;
var createI18n = function(param) {
    var locale = param.locale;
    i18next/* default.use */.ZP.use(context/* initReactI18next */.Db).init({
        resources: {
            en: en,
            ko: ko
        },
        lng: locale === types_locale/* LocaleEnum.ko */.U.ko ? types_locale/* LocaleEnum.ko */.U.ko : types_locale/* LocaleEnum.en */.U.en,
        fallbackLng: lngs[0],
        interpolation: {
            escapeValue: false
        },
        saveMissing: true,
        missingKeyHandler: sendInternationalizationError
    });
    return i18next/* default */.ZP;
};
/* harmony default export */ var src_i18n = (createI18n);

// EXTERNAL MODULE: ./src/constants/localstorage.ts
var localstorage = __webpack_require__(6446);
;// CONCATENATED MODULE: ./src/service/locale/storage.ts


var setLocale = function(param) {
    var locale = param.locale;
    if (__webpack_require__.g === null || __webpack_require__.g === void 0 ? void 0 : __webpack_require__.g.localStorage) {
        localStorage.setItem(LocalStorageEnum.Locale, locale);
        return;
    }
    console.error("setLocale 잘못된 코드 설정!");
};
var getLocale = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _fallback = ref.fallback, fallback = _fallback === void 0 ? true : _fallback;
    if (__webpack_require__.g === null || __webpack_require__.g === void 0 ? void 0 : __webpack_require__.g.localStorage) {
        var locale = localStorage.getItem(localstorage/* LocalStorageEnum.Locale */.m.Locale);
        return locale || (fallback ? lngs[0] : null);
    }
    return lngs[0];
};

;// CONCATENATED MODULE: ./src/service/locale/locale-config-hook.ts
// _app 에서 로케일 초기 셋텅 훅






var useLocaleConfig = function() {
    var locale = (0,router.useRouter)() // server 혹은 path 통해서 최초 locale 감지
    .locale;
    var i18n = react.useMemo(function() {
        return src_i18n({
            locale: locale
        });
    }, [
        locale
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(i18n), 2), i18nInstance = ref[0], setI18n = ref[1];
    // 마운트 후 localstorage에 있는 로케일 값으로 설정
    react.useEffect(function() {
        var localLocale = getLocale({
            fallback: false
        });
        if (// 로컬스토리지에 별도 언어 설정 값이 없는 경우 서버 로케일 우선
        localLocale !== null && localLocale !== locale && // /en path로 들어올 경우 localstorage(푸터 언어 설정) 설정값 무시
        locale === types_locale/* LocaleEnum.ko */.U.ko) {
            // path에 로케일 prepath가 없는 경우 로컬스토리지 언어설정값 우선
            setI18n(src_i18n({
                locale: localLocale
            }));
        }
    }, [
        locale
    ]);
    return {
        i18n: i18nInstance
    };
};
/* harmony default export */ var locale_config_hook = (useLocaleConfig);

;// CONCATENATED MODULE: ./src/service/locale/locale-provider.tsx




var LocaleProvider = function(param) {
    var children = param.children;
    var i18n = locale_config_hook().i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(I18nextProvider/* I18nextProvider */.a, {
        i18n: i18n,
        children: children
    });
};
/* harmony default export */ var locale_provider = (LocaleProvider);


/***/ }),

/***/ 2907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ LocaleEnum; }
/* harmony export */ });
/* unused harmony export KoreanEnum */
var LocaleEnum;
(function(LocaleEnum) {
    LocaleEnum["en"] = "en";
    LocaleEnum["ko"] = "ko";
})(LocaleEnum || (LocaleEnum = {}));
var KoreanEnum;
(function(KoreanEnum) {
    KoreanEnum["ko-kr"] = "ko-kr";
    KoreanEnum["ko"] = "ko";
    KoreanEnum["kr"] = "kr";
})(KoreanEnum || (KoreanEnum = {}));


/***/ }),

/***/ 1197:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 1197;
module.exports = webpackEmptyContext;

/***/ })

}]);